if (!customElements.get("dbtfy-back-in-stock")) {
  customElements.define(
    "dbtfy-back-in-stock",
    class extends HTMLElement {
      constructor() {
        super();

        this.is_message_showing = this.querySelector(
          ".newsletter-form__message"
        );

        this.body_message_input = this.querySelector(".body_message");
        this.animator = this.querySelector("element-animator");

        this.data = Debutify.widgets["dbtfy-back-in-stock"];

        this.errorMessage = this.data.already_subscribed_message;
        this.bodyMessage = this.data.dbtfy_back_in_stock_message;

        this.successMessageBox = this.querySelector(".success_message");

        this.submitButton = this.querySelector(
          'button[type="submit"]'
        );

        this.submitButtonIcon = this.querySelector(
          'button[type="submit"] .material-icon'
        );

        // Back In Stock Shopify tag field
        this.formTagInput = this.querySelector(
          'input[name="contact[tags]"]'
        );

        this.errorToast = document.querySelector(
          ".dbtfy-back-in-stock-error"
        );

        this.init();
        this.checkHasAnyError();
      }

      connectedCallback() {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const upsellPopup = document.querySelector(
            "dbtfy-upsell-popup"
          );

          if (
            !(
              (upsellPopup && upsellPopup?.opened == 1) ||
              (this.classList.add("hidden"),
              event.data.variant.available)
            )
          ) {
            const productName = event.data.variant.name;

            const message =
              this.data.dbtfy_back_in_stock_message.replace(
                "{product_title}",
                productName
              );

            this.body_message_input.value = message;

            // Update Shopify customer tags when variant changes
            this.setBackInStockTags(productName);

            this.classList.remove("hidden");
          }
        });

        if (this.is_message_showing) {
          this.classList.remove("hidden");
        }
      }

      init() {
        if (this.animator) {
          this.animator.dataset.animation =
            `dbtfy-element-animation-${this.data.dbtfy_back_in_stock_animation_type}`;

          this.animator.dataset.interval =
            this.data.dbtfy_back_in_stock_animation_interval;

          this.animator.dataset.duration =
            this.data.dbtfy_back_in_stock_animation_duration;
        }

        const productName = this.dataset.productName;

        const message =
          this.data.dbtfy_back_in_stock_message.replace(
            "{product_title}",
            productName
          );

        this.body_message_input.value = message;

        // Add product-specific Shopify customer tag
        this.setBackInStockTags(productName);

        if (this.successMessageBox) {
          this.successMessageBox.innerHTML =
            this.data.dbtfy_back_in_stock_success_message;
        }

        this.submitButton.insertAdjacentHTML(
          "beforeend",
          this.data.dbtfy_back_in_stock_button_name
        );

        if (this.submitButtonIcon) {
          this.submitButtonIcon.dataset.icon =
            this.data.dbtfy_back_in_stock_icon;
        }
      }

      setBackInStockTags(productName) {
        if (!this.formTagInput) return;

        if (!productName) {
          this.formTagInput.value = "back-in-stock";
          this.form_tag = this.formTagInput.value;
          return;
        }

        // Commas separate Shopify tags, so remove commas from product names
        const cleanProductName = String(productName)
          .replace(/,/g, " -")
          .trim();

        this.formTagInput.value =
          `back-in-stock, BIS: ${cleanProductName}`;

        this.form_tag = this.formTagInput.value;
      }

      checkHasAnyError() {
        const submittedTag = new URLSearchParams(
          window.location.search
        ).get("contact[tags]");

        if (submittedTag && submittedTag === this.form_tag) {
          if (this.errorToast) {
            this.toast =
              this.errorToast.closest(".dbtfy-toast");

            this.toast?.remove();
          }

          new Debutify.toast(
            `<div class="page-width dbtfy-back-in-stock-error">
              <p>${this.errorMessage}</p>
            </div>`,
            {
              position: "bottom-center",
              closeIcon: "close",
              colorScheme: this.colorScheme,
              customColorScheme: this.customColorScheme
            }
          );
        }
      }
    }
  );
}